module.exports = __webpack_public_path__ + "img/checked.fd9ac96b.svg";